export default __webpack_public_path__ + "static/0809-b31b587e20ad679f21eb67ff9eacbdb2.jpg";